import React from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import "./stepper.css";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(
  ({ theme, ownerState }) => ({
    color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
    ...(ownerState.active && {
      color: "#784af4",
    }),
    "& .QontoStepIcon-completedIcon": {
      color: "#784af4",
      zIndex: 1,
      fontSize: 18,
    },
    "& .QontoStepIcon-circle": {
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: "currentColor",
    },
  })
);

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

export default function CustomizedSteppers({ user }) {

  const getStepsV2 = () => {
    const steps = [
      {
        label: "Profile photo",
        path: "/",
        type: "all",
      },
      {
        label: "Work Location",
        path: "/PreferredWorkLocations",
        type: "all",
      },
      {
        label: "Address",
        path: "/personalDetails",
        type: "all",
      },
      {
        label: "ELT Certificate",
        path: "/resume",
        type: "elt",
      },
      {
        label: "Bachelor Degree",
        path: "/VocationalResume",
        type: "vet",
      },
      {
        label: "Qualifications",
        path: "/ececResume",
        type: "ecec"
      },
      {
        label: "Professional Experience",
        path: "/resume",
        type: "elt"
      },
      {
        label: "Professional Experience",
        path: "/ececResume",
        type: "ecec",
      },
      {
        label: "Industry Qualifications",
        path: "/VocationalResume",
        type: "vet",
      },
      { 
        label: "Industry Experience",
        path: "/VocationalResume",
        type: "vet",
      },
      {
        label: "WWCC",
        path: "/wwcc",
        type: "all"
      },
      {
        label: "First Aid (compulsory for ECEC)",
        path: "/ececcheck",
        type: "ecec",
      },
      {
        label: "USI (not compulsory)",
        path: "/usiCheck",
        type: "all",
      },
      {
        label: "Police Check (not compulsory)",
        path: "/policeCheck",
        type: "all",
      },
      {
        label: "Other Experience - VET (not compulsory)",
        path: "/VocationalResume",
        type: "vet",
      },
      {
        label: "Other Experience (not compulsory)",
        path: "/ececResume",
        type: "ecec",
      },
      {
        label: "Other Experience - ELT (not compulsory)",
        path: "/resume",
        type: "elt",
      },
      {
        label: "Can Deliver",
        path: "/",
        type: "all",
      },
      {
        label: "Upload Level Evidence",
        path: "/uploadPayLevel",
        type: "elt",
      },
      {
        label: "Reference Check",
        path: user?.is_elt
          ? "/resume"
          : (user?.is_vet ? "/VocationalResume" : "/ececResume"),
        type: "all",
      },
      {
        label: "Attend Onboarding Session",
        path: "https://www.readyteacherco.com/attend-onboarding",
        type: "all",
      },
    ];

    if (user?.is_childhood_teacher) {
      return steps.filter((step) => (step.type === "ecec" || step.type === "all") && step.label !== "Can Deliver")
    }

    if (user?.is_vet && user?.is_elt) {
      return steps.filter((step) => step.type === "elt" || step.type === "vet" || step.type === "all")
    }

    if (user?.is_vet) {
      return steps.filter((step) => step.type === "vet" || step.type === "all")
    }

    return steps.filter((step) => step.type === "elt" || step.type === "all")
  }


  const getStepsDataV2 = (user) => {
    const updateActiveStep = (step) => {
      step.active = true
      step.completed = true
    }
  
    const data = getStepsV2().map((step) => {
      step.active = false
      step.completed = false

      switch(step.label) {
        case "Profile photo":
          if (user.img_url) {
            updateActiveStep(step)
          }
          break;
        case "Work Location":
          if (user?.preferred_city1 && user?.preferred_country1) {
            updateActiveStep(step)
          }
          break;
        case "Address":
          if (user?.country && user?.state && user?.city && (user?.address_line1 || user?.address_line2)) {
            updateActiveStep(step)
          }
          break;
        case "ELT Certificate":
          if (user?.qualifications && user.qualifications.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Bachelor Degree":
          if (user?.vet_training_quals && user.vet_training_quals.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Qualifications":
          if (user?.qualifications && user.qualifications.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Professional Experience":
          if (user?.professional_experience && user.professional_experience.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Industry Qualifications":
          if (user?.vet_industry_quals && user.vet_industry_quals.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "Industry Experience":
          if (user?.vet_industry_exp && user.vet_industry_exp.length > 0) {
            updateActiveStep(step)
          }
          break;
        case "WWCC":
          if (user?.wwcc_filename && user?.wwcc_issuing_state) {
            updateActiveStep(step)
          }
          if (user?.is_childhood_teacher) {
            step.label = "WWCC (compulsory for ECEC)"
          }
          break;
        case "First Aid (compulsory for ECEC)":
          if(user?.ecec_filename && user?.ecec_url) {
            updateActiveStep(step)
          }
          break;
        case "USI (not compulsory)":
          if (user?.usi_downloaded_date && user?.usi_filename) {
            updateActiveStep(step)
          }
          break
        case "Can Deliver":
          if (user?.selected_can_delivers && user.selected_can_delivers.length > 0) {
            updateActiveStep(step)
          }
          break
        case "Police Check (not compulsory)":
          if (user?.police_check_type && user?.police_check_result) {
            updateActiveStep(step)
          }
          break
        case "Other Experience (not compulsory)":
          if (user?.non_teaching_experience && user?.non_teaching_experience.length > 0) {
            updateActiveStep(step)
          }
          break
        case "Attend Onboarding Session":
          if (user?.is_onboarded) {
            updateActiveStep(step)
          }
          break
        case "Upload Level Evidence":
          if (user?.pay_level?.status === "accepted") {
            updateActiveStep(step)
          }
          break
        case "Reference Check":
          if (user?.referees && user.referees.length > 0) {
            updateActiveStep(step)
          }
          break
      }

      return { ...step }
    })

    return data
  }

  const handleStepClick = (e, path, label) => {
    e.preventDefault()
    if(path) {
      if (label === "Attend Onboarding Session") {
        window.open(path, '_blank')
        return
      }

      window.location = path
    }
  }

  return (
    <Stack className="list-steps" sx={{ width: "100%" }} spacing={4}>
      <Stepper alternativeLabel connector={<QontoConnector />}>
        {getStepsDataV2(user).map((step, index) => (
          <Step key={index}>
            <StepLabel
              className="step-label"
              StepIconComponent={(props) => (
                <QontoStepIcon
                  {...props}
                  active={step.active}
                  completed={step.completed}
                />
              )}
            >
              <a
                className="step-link"
                href=""
                onClick={(e) => handleStepClick(e, step.path, step.label)}
              >
                {step.label}
              </a>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}
